import { render, staticRenderFns } from "./TranscriptionEditModal.vue?vue&type=template&id=1801bc1e&scoped=true&"
import script from "./TranscriptionEditModal.vue?vue&type=script&lang=js&"
export * from "./TranscriptionEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionEditModal.vue?vue&type=style&index=0&id=1801bc1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801bc1e",
  null
  
)

export default component.exports